import { useCallback } from "react";

import { useBlizzardEvents } from "../../analytics/hooks";
import { useTags } from "../../lens-tags/hooks";
import { type ModalProps, useToggleState } from "../../shared/hooks";
import { lensSpectaclesTagsAtomById } from "../../shared/state";

import { useLensChangeTracker } from "./useLensChangeTracker";

export const useSpectaclesTagsForm = (
    tags: readonly string[],
    lensId: string,
): {
    tagsList: readonly string[];
    addTag: (tag: string) => void;
    removeTag: (tag: string) => void;
    addTagsList: (tags: string[]) => void;
    updateLensLoading: boolean;
    openTagsModal: () => void;
    applyTags: () => void;
    tagsModalProps: ModalProps;
} => {
    const { sendBlizzardEvent } = useBlizzardEvents();
    const { tagsList, addTag, removeTag, addTagsList } = useTags(lensSpectaclesTagsAtomById(lensId));
    const { updateSpectaclesTags, updateLensLoading } = useLensChangeTracker(lensId);

    const [tagsModalProps, showTagsModal] = useToggleState();

    const openTagsModal = useCallback(() => {
        addTagsList(tags);

        showTagsModal();
    }, [tags, addTagsList, showTagsModal]);

    const applyTags = useCallback(() => {
        updateSpectaclesTags([...tagsList]);

        sendBlizzardEvent({
            event: "MYLENSES_MANAGEMENT_PAGE_ACTION",
            pageType: "LENS_DETAILS",
            action: "EDIT_TAGS",
        });
        tagsModalProps.onCancel();
    }, [updateSpectaclesTags, tagsList, tagsModalProps, sendBlizzardEvent]);

    return {
        tagsList,
        addTag,
        removeTag,
        addTagsList,
        updateLensLoading: updateLensLoading,
        openTagsModal,
        applyTags,
        tagsModalProps,
    };
};
